import {GridCellProps } from "@progress/kendo-react-grid"
import React from "react"
import { useNavigate, useParams } from "react-router"
import { useAppDispatch } from "../../../../app/hooks";
import { GridButton } from "../../../../components";
import { verifyApi } from "../../../../services/verifyService/verify-api";

function PayerSummaryViewCell(props:GridCellProps){
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {type,center,filter} = useParams();
    
    // Don't render button in group header rows
    if (props.dataItem.aggregates || props.dataItem.items) {
        return null;
    }
    
    return <React.Fragment>
        <GridButton variant={"outlined"} size='small' 
            color='primary'
            onClick={()=>{navigate('/Worklist/' + center + '/' + type + '/' + props.dataItem.payer); dispatch(verifyApi.util.invalidateTags(['worklist']));}}>View</GridButton>
    </React.Fragment>
}
export{PayerSummaryViewCell}